import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { EnvironmentLoader } from 'environments/utils/environment-loader.util';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
export function initApp(): () => Promise<void> {
    return () => EnvironmentLoader.loadEnvironment();
  }
const translationOptions = {
    loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
    },
};

@NgModule({
    imports: [TranslateModule.forRoot(translationOptions)],
    exports: [TranslateModule],
    providers: [{
                provide: APP_INITIALIZER,
                useFactory: initApp,
                multi: true,
              },TranslateService],
})
export class AppTranslationModule {
    constructor(private translate: TranslateService) {
        translate.addLangs(['en']);
        translate.setDefaultLang('en');
        translate.use('en');
    }
}
